import { render, staticRenderFns } from "./ArticleCollection.vue?vue&type=template&id=f738505a&lang=pug&"
import script from "./ArticleCollection.vue?vue&type=script&lang=js&"
export * from "./ArticleCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports